export default {
	functional: true,
	render(createElement, context) {
		return createElement('v-row', { props: { 'no-gutters': true } }, [
			createElement(
				'v-col',
				{
					class: 'shrink',
					style: 'min-width:150px',
					props: { cols: '12', md: 'auto' }
				},
				[
					createElement(
						'h3',
						{ class: 'body-1 font-weight-bold' },
						context.props.title
					)
				]
			),
			createElement('v-col', context.children)
		]);
	}
};
